import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle, ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const search = new URLSearchParams(useLocation().search);
  const sessionId = search.get("session_id");
  const paypalOrderId = search.get("paypal_order_id");
  const [status, setStatus] = useState("polling");
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!sessionId && !paypalOrderId) { setStatus("error"); return; }
    let attempts = 0; let cancelled = false;
    async function poll() {
      if (cancelled) return;
      attempts += 1;
      try {
        const url = paypalOrderId
          ? `${API}/paypal/order-status/${paypalOrderId}`
          : `${API}/checkout/status/${sessionId}`;
        const res = await axios.get(url);
        setDetails(res.data);
        if (res.data.payment_status === "paid") { setStatus("paid"); return; }
        if (res.data.status === "expired") { setStatus("expired"); return; }
      } catch { /* keep polling */ }
      if (attempts >= 8) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    }
    poll();
    return () => { cancelled = true; };
  }, [sessionId, paypalOrderId]);

  return (
    <div className="min-h-[80vh] flex items-center" data-testid="payment-success-page" style={{ background: "var(--ivory)" }}>
      <div className="max-w-2xl mx-auto px-6 text-center">
        {status === "polling" && (
          <>
            <Loader2 size={48} className="mx-auto animate-spin" style={{ color: "var(--brass)" }} />
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] mt-6" style={{ color: "var(--muted)" }}>Verifying transmission</div>
            <h1 className="font-display text-5xl mt-4" style={{ letterSpacing: "-0.03em" }}>Confirming payment…</h1>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={56} className="mx-auto" style={{ color: "var(--brass)" }} />
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] mt-6" style={{ color: "var(--muted)" }}>Confirmed</div>
            <h1 className="font-display text-6xl mt-4" style={{ letterSpacing: "-0.03em" }}>Deposit <span className="font-display-italic" style={{ color: "var(--brass)" }}>received.</span></h1>
            <p className="mt-6 font-body text-lg">Amount: <span className="font-mono" style={{ color: "var(--brass)" }}>${paypalOrderId ? (details?.amount || 0).toFixed(2) : (details?.amount_total || 0) / 100} {(details?.currency || "usd").toUpperCase()}</span></p>
            <p className="mt-2 font-body" style={{ color: "var(--muted)" }}>Bespoke will confirm your assessment window within 24 hours.</p>
            <Link to="/" className="btn-primary mt-10 inline-flex">Return Home <ArrowUpRight size={14} className="arrow" /></Link>
          </>
        )}
        {(status === "expired" || status === "timeout" || status === "error") && (
          <>
            <XCircle size={48} className="mx-auto" style={{ color: "var(--terracotta)" }} />
            <h1 className="font-display text-4xl mt-6" style={{ letterSpacing: "-0.03em" }}>Payment not confirmed</h1>
            <p className="mt-4 font-body" style={{ color: "var(--navy-soft)" }}>If you were charged, contact us — we'll resolve it immediately.</p>
            <Link to="/deposit" className="btn-ghost mt-10 inline-flex">Try Again</Link>
          </>
        )}
      </div>
    </div>
  );
}
